export default __webpack_public_path__ + "static/media/EMprint Bold.26265d11.woff";